import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

const PopupModel = ({show=false, setShow, children, size='xl', dialogClassName}) => {
  return (
    <>
      <Modal show={show} onHide={() => setShow({...show, isOpen:false})} size={size} centered dialogClassName={dialogClassName}>
        {children}
      </Modal>
    </>
  );
};

export default PopupModel;
